import { render } from "./about.vue?vue&type=template&id=917c4d0e&scoped=true&ts=true"
import script from "./about.vue?vue&type=script&lang=ts"
export * from "./about.vue?vue&type=script&lang=ts"

import "./about.vue?vue&type=style&index=0&id=917c4d0e&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\template\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917c4d0e"]])

export default __exports__